// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { Color, SolidBrush } from '@shared/commons/Graphics';
import { PlateBase } from './PlateBase';
import { PriceFormatter } from '@shared/utils/Instruments/PriceFormatter';
import { TerceraChartCashItemSeriesDataType } from '../Series/TerceraChartCashItemSeriesEnums';
import { StringUtils } from '@shared/utils/StringUtils';
export class PlateIndicator extends PlateBase {
    constructor(renderer) {
        super();
        this.Renderer = renderer;
        this.isIndicator = true;
    }
    GetHover() {
        return this.Renderer.Selected;
    }
    SetHover(value) {
        this.Renderer.Selected = value;
    }
    GetSelected() {
        return false;
    }
    GetVisible() {
        return this.Renderer.Visible;
    }
    Dispose() {
        this.Renderer = null;
    }
}
export class PlatePTLIndicator extends PlateIndicator {
    constructor(TerceraChartIndicatorRenderer) {
        super(TerceraChartIndicatorRenderer);
        /// <summary>
        /// replace from chart panel
        /// </summary>
        this.PTLIndicator = TerceraChartIndicatorRenderer.Indicator;
        this.lineColors = [];
        for (let i = 0; i < this.PTLIndicator.LinesCount; i++) {
            let c = this.PTLIndicator.LineColors[i];
            if (!c) {
                c = Color.Violet;
            }
            this.lineColors.push(new SolidBrush(c));
        }
    }
    getTextName() {
        return this.PTLIndicator.ShortName();
    }
    getTextValue(lastMouseHoverBarIndex, lineNumber, seriesSettings = null) {
        // TODO
        // var cv = this.PTLIndicator.lineIsConstantVector(lineNumber);
        // if (cv)
        //    return ''; //убрал возможность видеть LevelLine. думаю, это правильно. nicky.    красавчик!
        if (!this.PTLIndicator.LineVisible[lineNumber]) {
            return '';
        }
        // http://tp.pfsoft.net/entity/41138
        if (lastMouseHoverBarIndex < 0) {
            return StringUtils.THREE_DASHES;
        }
        const vector = this.PTLIndicator.getLineData(lineNumber);
        const value = vector.get(lastMouseHoverBarIndex);
        if (Math.abs(value) === Number.MAX_VALUE || isNaN(value) || value === 2147483647) {
            return 'N/A';
        }
        // if (value === 0)
        //     return "N/A"
        if (this.PTLIndicator.Digits < 0 || this.PTLIndicator.Digits > 8) {
            const dataType = seriesSettings !== null && this.Renderer.WindowsNumber === 0
                ? seriesSettings.DataType
                : TerceraChartCashItemSeriesDataType.Absolute;
            switch (dataType) {
                case TerceraChartCashItemSeriesDataType.Relative:
                    return seriesSettings.relativeDataConverter.Calculate(value).toFixed(2) + '%';
            }
            return PriceFormatter.formatPrice(value, 5);
        }
        else {
            return PriceFormatter.formatPrice(value, this.PTLIndicator.Digits);
        }
    }
    getBrush(lineNumber) {
        if (this.PTLIndicator.LineColors[lineNumber] !== this.lineColors[lineNumber].Color) {
            this.lineColors[lineNumber] = new SolidBrush(this.PTLIndicator.LineColors[lineNumber]);
        }
        return this.lineColors[lineNumber];
    }
    getLinesCount() {
        return this.PTLIndicator.LinesCount;
    }
    Dispose() {
        this.PTLIndicator = null;
        super.Dispose();
    }
    getTypeName() {
        return this.getPropertiesText() + ' ' + this.getTextName();
    }
    getCloseTT() {
        return this.getCloseText() + ' ' + this.getTextName();
    }
    getVisibilityTT() {
        return 'Show/Hide indicator lines';
    }
    getPropertiesText() {
        return Resources.getResource('chart.menu.PlateIndicatorSettings');
    }
    getCloseText() {
        return Resources.getResource('chart.menu.PlateIndicatorRemove');
    }
    getVisibilityText() {
        return Resources.getResource('chart.menu.PlateIndicatorVisible');
    }
    getMouseHoverBarIndex(lastMouseMovePt, window, cashItemSeries) {
        const cashItem = cashItemSeries.CashItem;
        if (lastMouseMovePt.IsEmpty()) {
            if (cashItem.isRealTimeBuilding) {
                return cashItem.FNonEmptyCashArray.length - 1; // last bar
            }
            else {
                return Math.round(window.i1);
            }
        }
        return super.getMouseHoverBarIndex(lastMouseMovePt, window, cashItemSeries);
    }
}
// #region
//    class PlateBuiltinIndicator : PlateIndicator
// {
//    iBuildInIndicator Builtin;
//    List<SolidBrush> lineColors;
//    public PlateBuiltinIndicator(TerceraChartBuiltinRenderer TerceraChartBuiltinRenderer)
//    : base(TerceraChartBuiltinRenderer)
//    {
//        this.Builtin = TerceraChartBuiltinRenderer.buildin;
//        lineColors = new List<SolidBrush>();
//        for (int i = 0; i < Builtin.Data.Length; i++)
//        {
//            Color c = Color.FromArgb(TerceraChartBuiltinRenderer._selColor[i]);
//            lineColors.Add(new SolidBrush(c));
//        }
// }
// public override string getTextName()
// {
//    string name = Builtin.Name;
//    if (name != null && name.EndsWith("Ex"))
//        return name.Substring(0, name.Length - 2);
//    else
//        return name;
// }
// public override string getTextValue(int lastMouseHoverBarIndex, int lineNumber, TerceraChartCashItemSeriesSettings seriesSettings = null)
// {
//            double value = Builtin.Data[lineNumber][lastMouseHoverBarIndex];
// if (value == int.MinValue || Math.Abs(value) == Int32.MaxValue || double.IsNaN(value))
//    value = 0;
// TerceraChart chart = Builtin.MainChart as TerceraChart;
// if (chart != null)
// {
//    var dataType = seriesSettings != null && Renderer.WindowsNumber == 0 ? seriesSettings.DataType : TerceraChartCashItemSeriesDataType.Absolute;
//    switch (dataType)
//    {
//        case TerceraChartCashItemSeriesDataType.Relative:
//            return seriesSettings.relativeDataConverter.Calculate(value).ToString("N2") + "%";
//    }
//    return chart.Instrument.formatPrice(value);
// }
// else
//    return com.pfsoft.proftrading.cache.Instrument.formatPrice(value, 5);
// }
// public override SolidBrush getBrush(int lineNumber)
// {
//            int color = ((TerceraChartBuiltinRenderer)Renderer)._selColor[lineNumber];
// if (Color.FromArgb(color) != lineColors[lineNumber].Color)
//    lineColors[lineNumber] = new SolidBrush(Color.FromArgb(color));
// return lineColors[lineNumber];
// }
// public override int getLinesCount()
// {
//    return Builtin.Data.Length;
// }
// public override void Dispose()
// {
//    Builtin = null;
//    base.Dispose();
// }
// }
// #endregion
